import { CurrencyEthIcon } from './CurrencyEthIcon';

/**
 * author: Peter Noble
 * id 222B8F14-2217-4FC1-8940-AC1CF8AB150B
 * name currency-eth
 * version: 2.0.46
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/currency-eth.svg
 * tags
 * - Currency 
 * - Banking 
 */
export const XiIcon = CurrencyEthIcon;
export default XiIcon